<template>
  <div class="managers-pay-page">
    <div class="content">
      <div class="title f20" style="text-align: center;">充值</div>
      <van-field
        v-model.number="amount"
        label="￥"
        placeholder="请输入充值金额"
        type="number"
        class="input pt20 pb40"
        clearable
      />
      <!-- <van-field v-model="remark" placeholder="请输入备注信息~" type="textarea" /> -->
    </div>
    <div class="btn">
      <van-button type="info" @click="createCharge">充 值</van-button>
    </div>

    <!-- <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { activity_id: activity.id }}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity: {},
      amount: null,
      user: {},
      remark: "",
      page: 1,
      loading: false,
      finished: false,
      record: [],
      targettype: "all",
      target: {
        all: "",
      },
    };
  },
  created() {
    // this.getUser();
    this.targettype = this.$route.query.type;
    console.log(this.targettype);
    this.target = this.pushkey(this.targettype);
    console.log(this.target);
    console.log(this.target[this.targettype]);
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 动态对象赋值
    pushkey(key) {
      let keyValue = {};
      keyValue[key] = null;
      return keyValue;
    },
    // 微信充值
    async createCharge() {
      if (/^\d+(\.\d{1,2})?$/.test(this.amount) == false) {
        this.$toast("请输入正确金额，最多两位小数");
        return;
      }
      this.chargeDetail = {
        amount: this.amount, //充值金额（元）,品牌单独充值的时候传
        chargeUserType: "finance", //充值用户类型：staff：导购员，brand：品牌方，finance：财务单独充
        type: this.targettype, //首次充值时不传，品牌单独充值时传
        //充值类型,当chargeUserType=finance时，需要传。brand_bonus_bean：品牌奖励豆奖金池，staff_bonus_bean：导购员奖励豆奖金池，brand_penalty：品牌惩罚承诺金，user_share_bonus：客户分享奖励，staff_single_bonus：导购员单项奖励金，live_red_package：直播间红包，other_promotion_expenses：其他推广费用
      };
      let res = await this.$http.post(
        `/v1/pay/create_charge`,
        this.chargeDetail
      );
      console.log(res);
      if (res.data && res.code == 0) {
        let tmp = {
          appId: res.data.appId, //公众号名称，由商户传入
          nonceStr: res.data.nonceStr, //随机串
          package: res.data.packageValue, //
          paySign: res.data.paySign, //微信签名
          signType: res.data.signType, //微信签名方式：
          timeStamp: res.data.timeStamp, //时间戳，自1970年以来的秒数

          // totalFee: res.data.totalFee, //本次充值支付金额(元)
          // tradeNo: res.data.tradeNo, //本次充值订单号
        };
        // tmp对象暂未确认，等待修改
        console.log(tmp);
        this.wechatPay(tmp);
      } else if (res.code == 20723) {
        // 充值成功后，跳转到首页
        this.$router.push({
          name: "kpi.home",
          query: {
            activity_id: this.activity.id,
            act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
          },
        });
      }
    },
    wechatPay(json) {
      console.log(json);
      const that = this;
      try {
        console.log(typeof WeixinJSBridge);
        if (typeof WeixinJSBridge !== "undefined") {
          WeixinJSBridge.invoke("getBrandWCPayRequest", json, (res) => {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              // that.$toast("支付成功！");
              // setTimeout(() => {
              //   this.$router.push({
              //     name: "kpi.home",query: {
              //   act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
              // },
              //   });
              // }, 5000);
              that.$toast("支付成功！");
              that.$router.push({
                path: "/kpi/managersrecharge",
                query: {
                  act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
                },
              });
            }
          });
        } else {
          that.$toast("请使用微信支付");
        }
      } catch (e) {
        that.$toast("服务器繁忙，请稍后再试");
      }
    },

    // 充值操作
    async saveBrandCharge() {
      let res = await this.$http.post(`/v1/kpiuser/finance_charge`, {
        amount: this.amount,
        type: this.targettype,
      });
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("充值成功！");
      }
    },

    getUser() {
      this.user = {
        balance: "500.99",
      };
    },
    /**
     * 提交提现申请
     * @returns {*}
     */
    onCreate() {
      if (!this.validate()) {
        return;
      }
      const json = {
        amount: this.amount,
        remark: this.remark,
      };
      this.$fn.showLoading();
      console.log("json", json);
      this.$fn.success("充值成功", () => {
        this.amount = null;
        this.remark = "";
      });
      this.$fn.closeLoading();
      // this.$fn.post('withdrawals', json, res => {
      //   this.$fn.closeLoading();
      //   if (res.status === 'error') {
      //     return this.$fn.fail(res.msg);
      //   }
      //   if (res.status === 'success') {
      //     this.$fn.success(res.msg, () => {
      //       this.amount = null;
      //     });
      //   }
      // });
    },
    getRecord() {
      const json = {
        page: this.page,
      };
      console.log("json", json);
      this.loading = true;
      // this.$fn.get('record', json, res => {
      //   if (res.status === 'error') {
      //     return this.$fn.fail('res.msg');
      //   }
      //   this.loading = false;
      //   this.record = this.record.concat(res.data);
      //   if (res.data.length > 0) {
      //     this.page++;
      //   }
      //   if (res.meta.current_page === res.meta.last_page) {
      //     this.finished = true;
      //   }
      // });
      this.record = [
        { money: "300", created_at: "2019-10-01 19:23:34" },
        { money: "3000", created_at: "2019-10-01 19:23:34" },
        { money: "1300", created_at: "2019-10-01 19:23:34" },
        { money: "300", created_at: "2019-10-01 19:23:34" },
        { money: "500", created_at: "2019-10-01 19:23:34" },
        { money: "300", created_at: "2019-10-01 19:23:34" },
        { money: "100", created_at: "2019-10-01 19:23:34" },
        { money: "900", created_at: "2019-10-01 19:23:34" },
      ];
      // this.record = [];
      this.loading = false;
      this.finished = true;
    },
    /**
     * 验证信息
     * @returns {*|void}
     */
    validate() {
      if (!this.amount) {
        return this.$fn.toast("请输入提现金额");
      }
      // if (!this.remark) {
      //   return this.$fn.toast('请输入备注信息');
      // }
      return true;
    },
  },
};
</script>

<style lang="less">
.managers-pay-page {
  .content {
    .title {
      padding: 10px 15px 0;
      background-color: #ffffff;
    }
    .tip {
      color: #999999;
    }
    .van-field__label {
      max-width: 25px;
      font-size: 24px;
      position: relative;
      top: 2px;
    }
    .input {
      font-size: 24px;
    }
  }
  .btn {
    width: 100%;
    text-align: center;
    margin: 20px 0;
    button {
      width: 90%;
    }
  }

  .tip {
    padding: 10px 15px;
    background-color: #ffffff;
    color: #1a1a1a;
    font-size: 13px;
    font-weight: bold;
  }
  .record {
    /*充值记录*/
    //background-color: #ffffff;
    //padding: 10px 15px;
    .bottom-line {
      background-color: #ffffff;
      padding: 10px 15px;
    }
    .bottom-line:after {
      left: 15px;
    }
    .time {
      color: #999999;
      margin-top: 5px;
      font-size: 12px;
    }
  }
}
</style>
